import { z } from 'zod';

import type {
  ClosePayPeriodRequest,
  ClosePayPeriodResponse,
  GetCurrentPayPeriodRequest,
  GetCurrentPayPeriodResponse,
  PayPeriodDto,
  PayPeriodStatus,
} from './pay-periods.dto.js';
import { payPeriodStatusValues } from './pay-periods.dto.js';

const timestampSchema = z.iso.datetime();

export const PayPeriodStatusSchema: z.ZodType<PayPeriodStatus> = z.enum(payPeriodStatusValues);

export const PayPeriodDtoSchema: z.ZodType<PayPeriodDto> = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  startDate: timestampSchema,
  endDate: timestampSchema,
  status: PayPeriodStatusSchema,
  closedAt: timestampSchema.nullable(),
  closedByUserId: z.uuid().nullable(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const GetCurrentPayPeriodRequestSchema: z.ZodType<GetCurrentPayPeriodRequest> = z.object({
  companyId: z.uuid(),
});

export const GetCurrentPayPeriodResponseSchema: z.ZodType<GetCurrentPayPeriodResponse> = z.object({
  payPeriod: PayPeriodDtoSchema,
});

export const ClosePayPeriodRequestSchema: z.ZodType<ClosePayPeriodRequest> = z.object({
  companyId: z.uuid(),
  payPeriodId: z.uuid(),
});

export const ClosePayPeriodResponseSchema: z.ZodType<ClosePayPeriodResponse> = z.object({
  payPeriod: PayPeriodDtoSchema,
});

